import { render } from "./InviteRedirect.vue?vue&type=template&id=4d274c9f"
import script from "./InviteRedirect.vue?vue&type=script&lang=js"
export * from "./InviteRedirect.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__